export const HABILITADO = 'HAB'
export const INHABILITADO = 'INH'

export const __dictionary = {
  [HABILITADO]: {
    id: HABILITADO,
    nombre: 'HABILITADO'
  },
  [INHABILITADO]: {
    id: INHABILITADO,
    nombre: 'INHABILITADO'
  }
}

export const __array = [__dictionary[HABILITADO], __dictionary[INHABILITADO]]
